module.exports = __webpack_public_path__ + "img/mm2icon.1d26278a.png";